import { render, staticRenderFns } from "./UnderMaintenance.vue?vue&type=template&id=08502054&"
import script from "./UnderMaintenance.vue?vue&type=script&lang=js&"
export * from "./UnderMaintenance.vue?vue&type=script&lang=js&"
import style0 from "./UnderMaintenance.vue?vue&type=style&index=0&id=08502054&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08502054')) {
      api.createRecord('08502054', component.options)
    } else {
      api.reload('08502054', component.options)
    }
    module.hot.accept("./UnderMaintenance.vue?vue&type=template&id=08502054&", function () {
      api.rerender('08502054', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/miscellaneous/UnderMaintenance.vue"
export default component.exports